import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { type AppViewNavigation } from '@/components/templates/AppView'

export function useTeamStatusDropdown(): Pick<AppViewNavigation, 'teamStatusOptions'> {
  const intl = useIntl()

  return useMemo(
    () => ({
      teamStatusOptions: {
        placeholder: (teamNumber) => intl.formatMessage({ id: 'selector.teamStatus.label' }, { teamNumber }),
        options: [
          {
            text: intl.formatMessage({ id: 'selector.teamStatus.gps' }),
            value: 'gps',
          },
          {
            text: intl.formatMessage({ id: 'selector.teamStatus.region' }),
            value: 'region',
          },
          {
            text: intl.formatMessage({ id: 'selector.teamStatus.pause' }),
            value: 'pause',
          },
          {
            text: intl.formatMessage({ id: 'selector.teamStatus.return' }),
            value: 'return',
          },
        ],
      },
    }),
    [intl]
  )
}
